import Image1 from "../../Assets/Rough Emerald/63c203024d11788d66ec755011fcc71a.jpg"
import Image2 from "../../Assets/Rough Emerald/292f2e634e76e2b94b0cee89de523ed2.jpg"
import Image3 from "../../Assets/Rough Emerald/528976bfbf695cadce08a55703a2d298.jpg"
import Image4 from "../../Assets/Rough Emerald/112447571ba1e22c7d8274652f18a395.jpg"
import Image5 from "../../Assets/Rough Emerald/a1a044962d935cfc33b3798e2462bb7c.jpg"
import Image6 from "../../Assets/Rough Emerald/c5e5f0dce76124239f0854d037c369d5.jpg"
import Image7 from "../../Assets/Photos new/image_2025-05-25_12-07-29.png"
import Image8 from "../../Assets/Photos new/image_2025-05-25_12-07-50.png"






export const roughEmeralds = [
    {
      id: "r1",
      image: Image1,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r2",
      image: Image2,
      weight: 98.3,
      origin: "Zambia",
      color: "Vivid Green",
      formation: "Schist",
      price: "$9,800",
      dimensions: "3.8 × 2.9 × 2.5 cm",
    },
    {
      id: "r3",
      image: Image3,
      weight: 156.2,
      origin: "Brazil",
      color: "Medium Green",
      formation: "Pegmatite",
      price: "$15,600",
      dimensions: "5.1 × 3.7 × 3.2 cm",
    },
    {
      id: "r4",
      image: Image4,
      weight: 87.5,
      origin: "Ethiopia",
      color: "Bluish Green",
      formation: "Hydrothermal",
      price: "$8,750",
      dimensions: "3.5 × 2.8 × 2.3 cm",
    },
    {
      id: "r5",
      image: Image5,
      weight: 112.8,
      origin: "Afghanistan",
      color: "Rich Green",
      formation: "Hydrothermal",
      price: "$11,280",
      dimensions: "4.0 × 3.2 × 2.7 cm",
    },
    {
      id: "r6",
      image: Image6,
      weight: 143.5,
      origin: "Colombia",
      color: "Deep Bluish Green",
      formation: "Hydrothermal",
      price: "$14,350",
      dimensions: "4.5 × 3.4 × 3.0 cm",
    },
    {
      id: "r6",
      image: Image7,
      weight: 143.5,
      origin: "Colombia",
      color: "Deep Bluish Green",
      formation: "Hydrothermal",
      price: "$14,350",
      dimensions: "4.5 × 3.4 × 3.0 cm",
    },
    {
      id: "r6",
      image: Image8,
      weight: 143.5,
      origin: "Colombia",
      color: "Deep Bluish Green",
      formation: "Hydrothermal",
      price: "$14,350",
      dimensions: "4.5 × 3.4 × 3.0 cm",
    },
  ]
  